export const TutorialRoute = {
  /** DEV ONLY: preview of the start card and the tour without a login. */
  TourPreview: 'tour-preview'
} as const;

export type TutorialRoute = (typeof TutorialRoute)[keyof typeof TutorialRoute];

export type TutorialParam = {
  [TutorialRoute.TourPreview]: undefined;
};
